import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
        
        // Binding
        this.onClickBind = this.onClick.bind(this)

        // UI
        this.$el = this.el
        
        // Data
        this.productID = this.getData('id')
    }

    ///////////////
    // Lifecyle
    ///////////////
    init() {
        this.bindEvents();
    }

    destroy() {
        super.destroy();
        this.unbindEvents();
    }

    ///////////////
    // Events
    ///////////////
    bindEvents() {
        this.$el.addEventListener('click', this.onClickBind)
    }

    unbindEvents() {
        this.$el.removeEventListener('click', this.onClickBind)
    }

    ///////////////
    // Callbacks
    ///////////////
    onClick() {
        this.addToCart()
    }

    ///////////////
    // Methods
    ///////////////
    addToCart() {
        this.call('addItem', { id: parseInt(this.productID, 10), quantity: 1 }, 'CartModal')
    }
}
